import NtS from 'visuris/Data/Entities/NtS';
import { BaseRepository } from 'visuris/Data/Repositories/BaseRepository';
import * as $ from 'jquery';
import * as app from 'CMS/core/application';
import OperationEvent from 'visuris/Data/Entities/OperationEvent';
import * as facilityhelp from 'visuris/Helpers/FacilityHelper';
import ActionResult from 'visuris/Data/DTOs/ActionResult';

export default class NtSRepository extends BaseRepository<NtS> {

    // See constructor
    private GETNTSMESSAGE = "";
    private GETNTSMESSAGESFOROBJECTID = "";
    private GETMOSTRECENTNTSMESSAGES = "";
    private GET_PDF_URI = "";
    private GET_MESSAGE_VIEW = "";
    private GET_MESSAGE_GRID_VIEW = "";
    private GET_CODE_VIEW = "";
    private GET_EDIT_URI_FOR_NTS = "";
    private GET_BY_NUMBER = "";
    private GET_BY_INTERNAL_ID = "";
    private GETNTSOPERATIONTIMESFOROBJECTID = "";
    private TRIGGERNTSMISSINGDATARELOAD = "";
    constructor() {
        super();
        this.GETNTSMESSAGE = app.formatLocationUrl("~/visuris/api/ntsV2/getntsmessage?identifier=");
        this.GETNTSMESSAGESFOROBJECTID = app.formatLocationUrl("~/visuris/api/ntsV2/getntsmessagesforobjectid?objectID=");
        this.GETMOSTRECENTNTSMESSAGES = app.formatLocationUrl("~/visuris/api/ntsV2/getmostrecentntsmessages?amount=");
        this.GET_PDF_URI = app.formatLocationUrl("~/visuris/api/ntsV2/getpdfuri");
        this.GET_EDIT_URI_FOR_NTS = app.formatLocationUrl("~/visuris/api/ntsV2/getedituri");
        this.GET_MESSAGE_VIEW = app.formatLocationUrl("~/visuris/api/ntsV2/getmessageview");
        this.GET_MESSAGE_GRID_VIEW = app.formatLocationUrl("~/visuris/api/ntsV2/GetMessageGridView");
        this.GET_CODE_VIEW = app.formatLocationUrl("~/visuris/api/ntsV2/getcodeview");
        this.GET_BY_NUMBER = app.formatLocationUrl("~/visuris/api/ntsV2/GetNtSMessageByNumber");
        this.GET_BY_INTERNAL_ID = app.formatLocationUrl("~/visuris/api/ntsV2/GetNtSMessageByInternalId");
        this.GETNTSOPERATIONTIMESFOROBJECTID = app.formatLocationUrl("~/visuris/api/ntsV2/GetNtSOperationTimesForObjectID?objectID=");
        this.TRIGGERNTSMISSINGDATARELOAD = app.formatLocationUrl("~/visuris/api/ntsV2/TriggerNtSMissingDataReload");
    }

    public list(): Promise<NtS[]> {
        throw new Error('list is not implemented');
    }

    public get(id: string): Promise<NtS> {
        return new Promise<NtS>((resolve, reject) => {
            var $get = $.get(this.GETNTSMESSAGE + id);
            $get.then((data) => {
                resolve(NtSRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public getByNumber(number: string, organisation: string): Promise<NtS> {
        return new Promise<NtS>((resolve, reject) => {
            var $get = $.get(this.GET_BY_NUMBER + "?number=" + number + "&organisation=" + organisation);
            $get.then((data) => {
                resolve(NtSRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }
    public getByInternalId(internalId: string, organisation: string): Promise<NtS> {
        return new Promise<NtS>((resolve, reject) => {
            var $get = $.get(this.GET_BY_INTERNAL_ID + "?internalId=" + internalId + "&organisation=" + organisation);
            $get.then((data) => {
                resolve(NtSRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public listForObjectID(objectID: string): Promise<NtS[]> {
        return new Promise<NtS[]>((resolve, reject) => {
            var $get = $.get(this.GETNTSMESSAGESFOROBJECTID + objectID);
            $get.then((data) => {
                var ntsmessages: NtS[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    ntsmessages.push(NtSRepository.fromDTO(item));
                }
                resolve(ntsmessages);
            }, () => {
                reject();
            });
        });
    }

    public listMostRecent(amount: number): Promise<NtS[]> {
        return new Promise<NtS[]>((resolve, reject) => {
            var $get = $.get(this.GETMOSTRECENTNTSMESSAGES + amount.toString());
            $get.then((data) => {
                var ntsmessages: NtS[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    ntsmessages.push(NtSRepository.fromDTO(item));
                }
                resolve(ntsmessages);
            }, () => {
                reject();
            });
        });
    }

    public getPDFUri(headerID: string, sectionID: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            var $get = $.get(this.GET_PDF_URI + "?headerID=" + headerID + "&sectionID=" + sectionID);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }

    public getEditUri(headerID: string, sectionID: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            var $get = $.get(this.GET_EDIT_URI_FOR_NTS + "?headerID=" + headerID + "&sectionID=" + sectionID);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }

    public getCodeView(headerID: string, sectionID: string, languageCode: string = null): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            var url = this.GET_CODE_VIEW + "?headerID=" + headerID + "&sectionID=" + sectionID;
            if (languageCode != null) {
                url += "&languageCode=" + languageCode;
            }
            var $get = $.get(url);
            $get.then((data) => {
                resolve(data);
            }, (error) => {
                console.error(error);
                reject();
            });
        });
    }

    public getMessageView(headerID: string, sectionID: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            var $get = $.get(this.GET_MESSAGE_VIEW + "?headerID=" + headerID + "&sectionID=" + sectionID);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }
    public getMessageGridView(headerID: string, sectionID: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            var $get = $.get(this.GET_MESSAGE_GRID_VIEW + "?headerID=" + headerID + "&sectionID=" + sectionID);
            $get.then((data) => {
                resolve(data);
            }, (error: any) => {
                reject(error);
            });
        });
    }
    public listNtSOperationTimesForObjectID(isrs: string): Promise<OperationEvent[]> {
        return new Promise<OperationEvent[]>((resolve, reject) => {
            var $get = $.get(this.GETNTSOPERATIONTIMESFOROBJECTID + isrs);
            $get.then((data) => {
                var operationEvents: OperationEvent[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    operationEvents.push(facilityhelp.toOperationEvent(item));
                }
                resolve(operationEvents);
            }, () => {
                reject();
            });
        });
    }

    public async triggerNtSMissingDataReload(headerId?: string, sectionId?: string, countryCode?: string): Promise<ActionResult> {
        let data = {};
        if (headerId && sectionId) {
            data = {
                headerId: headerId,
                sectionId: sectionId
            };
        }
        else if (countryCode) {
            data = {
                countryCode: countryCode,
            };
        }
        return $.post({ url: this.TRIGGERNTSMISSINGDATARELOAD, data: JSON.stringify(data), contentType: 'application/json' });
    }

    public static fromDTO(item: any): NtS {
        var nts = new NtS();
        nts.headerId = item.headerID;
        nts.sectionId = item.sectionId;
        nts.organisation = item.organisation;
        nts.dateIssue = item.dateIssue != null ? new Date(item.dateIssue) : null;
        nts.dateStart = item.dateStart != null ? new Date(item.dateStart) : null;
        nts.dateEnd = item.dateEnd != null ? new Date(item.dateEnd) : new Date(8640000000000000);
        nts.state = item.state;
        nts.messageType = item.messageType;
        nts.title = item.title;
        nts.internalId = item.internalId;
        nts.versionId = item.versionId;
        nts.year = item.year;
        nts.number = item.number;
        nts.serialNumber = item.serialNumber;
        nts.displayOnMap = item.displayOnMap;
        nts.xsdVersion = item.xsdVersion;
        nts.versionNumber = item.versionNumber;
        nts.hindranceState = item.hindranceState;
        nts.internalMessage = item.internalMessage;
        nts.hindranceStateMessage = item.hindranceStateMessage;
        nts.xml = item.xml;
        nts.stateMessage = item.stateMessage;
        nts.messageTypeMessage = item.messageTypeMessage;
        nts.country = item.country;
        nts.countryCode = item.countryCode;
        nts.originator = item.originator;
        nts.missingData = item.missingData;

        nts.relatedFairways = [];
        if (item.relatedFairways != null) {
            item.relatedFairways.forEach((rfw: string) => {
                nts.relatedFairways.push(rfw);
            });
        }

        nts.targetaudiences = [];
        if (item.targetaudiences != null) {
            item.targetaudiences.forEach((ta: string) => {
                nts.targetaudiences.push(ta);
            });
        }

        nts.limitations = [];
        if (item.limitations != null) {
            item.limitations.forEach((lmt: string) => {
                nts.limitations.push(lmt);
            });
        }
        return nts;
    }
}

